function responsiveTable() {
    const tables = document.querySelectorAll('.woocommerce-Tabs-panel--description table');

    if (!tables.length) {
        return;
    }

    const responsiveClassName = 'responsive-table';

    tables.forEach(table => {
        table.closest('div').classList.add(responsiveClassName);
    });
}

export default responsiveTable;
